/**
 * 挂载全局的一些配置/调用入口等
 * @author zhenn
 * @createTime 2017-10-23
 */

import Map from 'core-js/es6/map';
import Set from 'core-js/es6/set';
import Promise from 'bluebird/js/browser/bluebird.min';
import {createHashHistory} from 'history';
import lang from '../lang';
import Url from 'c-url';
import Cache from 'c-cache';
import Loading from 'c-loading';
import Notice from 'c-notification';
import native from 'c-up-native';
import Profile from '../component/profile';
import Dialog from '../host/common/dialog';
import PublicPb from '../pb/resultresponse.pb';

let UG = {
    // auth,
    cache: new Cache({
        prefix: 'uplive'
    }), // 全局缓存对象
    lang,
    router: createHashHistory(),
    clientType: 'h5uplive_universalgift', // 充值跟踪字段
    userChannel: 'h5_universalGifting',
    getGlobalUA() {
        // 用户注册渠道，用于跟踪用户数据（登录、充值等等）
        let channel = this.userChannel;
        let UserAgent = 'H5/' + channel + ' version/9.9.9';
        if (window.smDeviceId) {
            UserAgent += ' smd/' + window.smDeviceId;
        }
        return UserAgent;
    },

    getLoginUserProfile(success, fail) {

        let user = this.getUser();
        let failCount = 0;

        let getUserProfile = () => {
            let promise = Profile.getUserInfo(user.uid);

            promise.then((msg) => {

                msg.uid = longToString(msg.uid);
                msg.balance = msg.balance || {};
                msg.balance.bill = msg.balance.bill ? longToString(msg.balance.bill) : 0;
                msg.balance.diamond = msg.balance.diamond ? longToString(msg.balance.diamond) : 0;
                msg.balance.inBill = msg.balance.inBill ? longToString(msg.balance.inBill) : 0;
                msg.balance.outDiamond = msg.balance.outDiamond ? longToString(msg.balance.outDiamond) : 0;

                success(msg);

            }).catch(() => {
                failCount++;
                if (failCount === 3) {
                    fail();
                } else {
                    getUserProfile();
                }

            });
        };

        getUserProfile();

    },

    // 从local中获取登录成功的用户信息，含uid和usertoken
    getUser() {
        return this.cache.getCache('user') || {};
    },

    clearUser() {
        this.cache.removeCache('user');
    },

    // 存储完整的用户信息（从profile中获取）
    loginUserInfo: null,

    setTitle(title) {
        // 这个title需要设置对应的网页的title
        document.title = title;
        // IOS
        native.setTitle({
            title,
            errtip() {
                console.log('不支持该协议');
            }
        });
    },
    native: native,
    platform: native.getPlatform(),
    isUplive: native.getPlatform() === 'uplive' || localStorage.getItem('isUplive'),
    isStage: Url.query('env') === 'stage',
    isVistor: () => {
        return UG.getUser().isVisitor;
    }
};

if (UG.isUplive) {
    localStorage.setItem('isUplive', true);
}

// 弹出一个提示窗
UG.confirm = Dialog.confirm;
// toast
UG.simple = Notice.simple;
// 正在加载
UG.loading = content => Loading.show({text: content});
//  里面绑定了this ： UG.loaded = Loading.hide 无效
UG.loaded = () => Loading.hide();

/**
 * 加一个切换页面加载数据延迟1000ms的方法，因为加载总是很快的，如果太快就不显示loading了
 * @param msg 显示的加载的文本
 * @param timeout 延时时长
 * @returns {Function}
 */
UG.initLoading = function (msg, timeout = 1000) {
    let out = setTimeout(function () {
        UG.loading(msg);
        clearTimeout(out);
        out = null;
    }, timeout);
    return function () {
        out ? clearTimeout(out) : UG.loaded();
    };
};

/**
 * Iscroll 在安卓和ios上点击事件有问题，在配置项必须加上click
 * {
 *  click: UG.iScrollClick()
 * }
 * @returns {boolean}
 */
UG.iScrollClick = () => {
    if (/iPhone|iPad|iPod|Macintosh/i.test(navigator.userAgent)) return false;
    if (/Chrome/i.test(navigator.userAgent)) return (/Android/i.test(navigator.userAgent));
    if (/Silk/i.test(navigator.userAgent)) return false;
    if (/Android/i.test(navigator.userAgent)) {
        let s = navigator.userAgent.substr(navigator.userAgent.indexOf('Android') + 8, 3);
        return !(parseFloat(s[0] + s[3]) < 44);
    }
};

UG.isIOS = (/iPhone|iPad|iPod/i).test(window.navigator.userAgent);
// 系统版本号
UG.osVersion = (function () {
    const ua = navigator.userAgent;
    let osVersion = ua.match(/(?:OS|Android)[\/\s](\d+[._]\d+(?:[._]\d+)?)/i);

    if (osVersion) {
        osVersion = (osVersion[1] || '0.0.0').replace(/\_/g, '.');
    } else {
        osVersion = '0.0.0';
    }
    return osVersion;
})();

UG.compareVersion = function (v1, v2) {
    v1 = v1.toString().split('.');
    v2 = v2.toString().split('.');

    for (var i = 0; i < v1.length || i < v2.length; i++) {
        var n1 = parseInt(v1[i], 10), n2 = parseInt(v2[i], 10);

        if (window.isNaN(n1)) {
            n1 = 0;
        }
        if (window.isNaN(n2)) {
            n2 = 0;
        }
        if (n1 < n2) {
            return -1;
        } else if (n1 > n2) {
            return 1;
        }
    }
    return 0;
};
/**
 * IOS9不支持剪切板要做特殊处理
 * @returns {boolean}
 */
UG.isIOS9 = () => {
    const ua = navigator.userAgent;
    return ua.indexOf('iPhone OS 9') !== -1;
};

/**
 * 保留小数点
 * @param {Number} num
 * @param {Number} no
 * @returns {number}
 */
UG.toNumFixed = (num, no = 4) => {
    return parseFloat(Number(num).toFixed(no));
};

// 是否支持blob和download属性
UG.supportBlobAndDownload = 'download' in document.createElement('a') && 'toBlob' in document.createElement('canvas');

window.UG = UG;
window.Map = Map;
window.Set = Set;
window.Code = PublicPb.Code;
window.Promise = Promise;
if (!DEBUG) {
    window.alert = msg => msg;
}

// 防止有些浏览器不支持
console.groupCollapsed = console.groupCollapsed || console.log;
console.groupEnd = console.groupEnd || (a => a);



// WEBPACK FOOTER //
// ./js/base/global.js